<ng-container>
  @if (content.useAccessibleCalculator) {
    <div class="row mb-1">
      <div class="col-12">
        <wl-rich-text-wrapper
          [field]="{ value: content.usageQuestionnaireTitle }"
          ><p
            class="h6 mt-0 mb-0 fw-bold"
            wlAutomationId="usage-questionnaire-title"
          ></p
        ></wl-rich-text-wrapper>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-12 col-md-12">
        <div class="d-grid gap-2">
          @if (content.manualButtonLabel) {
            <crnt-button
              variant="primary"
              (click)="setQuestionnaireContainerVisibility.emit(true)"
              wlAutomationId="calculate-form-consumption-help.ManualButton"
            >
              {{ content.manualButtonLabel }}
            </crnt-button>
          }
          @if (content.calculatorButtonLabel) {
            <crnt-button
              variant="secondary"
              (click)="calculateOpenModal.emit()"
              wlAutomationId="calculate-form-consumption-help.EstimationToolButton"
            >
              {{ content.calculatorButtonLabel }}
            </crnt-button>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="row mb-1">
      <div class="col-12">
        <wl-rich-text-wrapper
          [field]="{ value: content.usageQuestionnaireTitle }"
          ><p
            class="h6 mt-0 mb-0 fw-bold"
            wlAutomationId="usage-questionnaire-title"
          ></p
        ></wl-rich-text-wrapper>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-12 col-md-12">
        <div class="d-grid gap-2">
          @if (content.manualButtonLabel) {
            <button
              class="btn btn-outline-primary"
              type="button"
              (click)="setQuestionnaireContainerVisibility.emit(true)"
              wlAutomationId="calculate-form-consumption-help.ManualButton"
            >
              {{ content.manualButtonLabel }}
            </button>
          }
          @if (content.calculatorButtonLabel) {
            <button
              class="btn btn-outline-primary"
              wlAutomationId="calculate-form-consumption-help.EstimationToolButton"
              (click)="calculateOpenModal.emit()"
            >
              {{ content.calculatorButtonLabel }}
            </button>
          }
        </div>
      </div>
    </div>
  }
</ng-container>
